import { Navigate } from "react-router-dom";
import { JSX } from "react";
import { useAppSelector } from "../../app/hooks";
import {
  selectIsAdmin,
  selectAuthInitializationStatus,
  selectIsAuthenticated,
} from "../../features/authentication/authenticationSlice";
import { ROUTES } from "../../routes";

/**
 * Gates admin-only routes. Waits for auth to hydrate, then redirects anyone who
 * is not a back-office admin to the login page (unauthenticated) or home
 * (authenticated, non-admin). The server independently enforces the Admin role.
 */
const RequireAdmin = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isAdmin = useAppSelector(selectIsAdmin);
  const isInitialized = useAppSelector(selectAuthInitializationStatus);

  if (isInitialized !== "initialized") {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (!isAdmin) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return children;
};

export default RequireAdmin;
